import React from "react";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";

export default function WhatsAppContact({ property, variant = "card" }) {
  const { settings, feature } = useSettings();
  const number = (settings?.whatsapp_number || "").replace(/[^0-9]/g, "");
  if (!feature("whatsapp_enquiry") || !number || !property) return null;

  const location = [property.area_name, property.city].filter(Boolean).join(", ");
  const propUrl = `${window.location.origin}/property/${property.id}`;
  const text = `Hi, I'm interested in this property:\n*${property.title}*\nLocation: ${location}${property.pincode ? ` - ${property.pincode}` : ""}\nProperty ID: ${property.short_code || property.id}\nLink: ${propUrl}\n\nPlease share more details.`;

  const onClick = (e) => {
    e.stopPropagation();
    // Open synchronously with the gesture (mobile Safari blocks async window.open), then log.
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(text)}`, "_blank");
    api.post("/whatsapp-enquiries", { property_id: property.id }).catch((err) => console.debug("wa enquiry log failed", err));
  };

  if (variant === "detail") {
    return (
      <Button onClick={onClick} data-testid={`wa-contact-${property.id}`} className="rounded-full bg-brand-lease hover:bg-brand-lease/90 text-white">
        <MessageCircle className="w-4 h-4 mr-1.5" /> Contact on WhatsApp
      </Button>
    );
  }
  return (
    <button onClick={onClick} data-testid={`wa-contact-${property.id}`} title="Contact on WhatsApp"
      className="w-8 h-8 rounded-full flex items-center justify-center bg-brand-lease/10 text-brand-lease hover:bg-brand-lease hover:text-white transition-colors">
      <MessageCircle className="w-4 h-4" />
    </button>
  );
}
